import { useState } from 'react';
import { replace, type MiddlewareFunction } from 'react-router';
import { paths } from '~/common/app/paths';

export function discoveryAccepted({ url }: MiddlewareArgs): void {
  requireAccepted(url, paths.discoveryEvaluatorWelcome.href({}));
}

export function discoveryApiAccepted({ url }: MiddlewareArgs): void {
  requireAccepted(url, paths.discoveryApiEvaluatorWelcome.href({}));
}

export function exploreAccepted({ url }: MiddlewareArgs): void {
  requireAccepted(url, paths.exploreEvaluatorWelcome.href({}));
}

export function discoveryFullCircleAccepted({ url }: MiddlewareArgs): void {
  requireAccepted(url, paths.discoveryFullCircleEvaluatorWelcome.href({}));
}

export function useAcceptedPrivacyPolicy(): PrivacyPolicy {
  const [isAccepted, setIsAccepted] = useState(accepted);

  return {
    accepted: isAccepted,
    accept: () => {
      acceptPrivacyPolicy();
      setIsAccepted(true);
    },
  };
}

export type PrivacyPolicy = {
  accepted: boolean;
  accept: () => void;
};

type MiddlewareArgs = Parameters<MiddlewareFunction>[0];

let accepted = false;

function requireAccepted(url: URL, welcome: string): void {
  if (!accepted)
    throw replace(`${welcome}${url.search}${window.location.hash}`);
}

export function acceptPrivacyPolicy(): void {
  accepted = true;
}

export function clearAcceptedPrivacyPolicy(): void {
  accepted = false;
}
